var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useEffect } from "react";
import { acceptNumberOnly, } from "@frameworks/web/components/features/TOC/constant";
import InputField from "@frameworks/web/components/generic/inputField";
import { RedeemCard } from "./RedeemCard";
import "@frameworks/shared-library/stylesheets/components/TransactionJourney/RedeemSIP/RedeemSIP.scss";
import GenericCheckbox from "@frameworks/shared-library/components/GenericCheckbox/GenericCheckbox";
import { EValueType, } from "@frameworks/shared-library/components/GenericDetails/GenericDetails";
import { roundUpToThreeDecimalPlaces } from "@domains/utils/numberMethods";
import FolioSelection from "../CommonComp/FolioSelection";
import { floatNumExp } from "@frameworks/salesjourney/utils/regex";
import GenericTooltip from "@frameworks/shared-library/components/GenericTooltip";
import GenericTooltipInnerContent from "@frameworks/shared-library/components/GenericTooltipInnerContent";
import { EHoldingType } from "@domains/features/TOCJourney/entities/MFPurchaseOrderEntity";
import { EReedemType } from "../MutualFundConstant";
var RedeemSIP = function (props, ref) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    var _q = __read(useState(false), 2), schemeError = _q[0], setSchemeError = _q[1];
    var _r = __read(useState([]), 2), genericDetailsAccordianData = _r[0], setGenericDetailsAccordianData = _r[1];
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        // we can move this to RedeemCard component need to check
        if (props.folio) {
            var genericDetailsAccordianData_1 = [
                {
                    label: "Long term units",
                    value: "".concat((_a = props.folio) === null || _a === void 0 ? void 0 : _a.longTermQty, "(Approx)/ \u20B9").concat(roundUpToThreeDecimalPlaces(+((_b = props.folio) === null || _b === void 0 ? void 0 : _b.longTermQty) * +((_c = props.folio) === null || _c === void 0 ? void 0 : _c.nav)), " "),
                },
                {
                    label: "Short term units",
                    value: "".concat((_d = props.folio) === null || _d === void 0 ? void 0 : _d.shortTermQty, "(Approx)/\u20B9").concat(roundUpToThreeDecimalPlaces(+((_e = props.folio) === null || _e === void 0 ? void 0 : _e.shortTermQty) * +((_f = props.folio) === null || _f === void 0 ? void 0 : _f.nav))),
                },
                {
                    label: "Redemption Time",
                    value: (_g = props.folio) === null || _g === void 0 ? void 0 : _g.redemptionTime,
                },
                // {
                //   label: (
                //     <span>
                //       <GenericTooltip
                //         placement={"bottom"}
                //         toolTipText={
                //           <GenericTooltipInnerContent
                //             tooltipTitle={
                //               "A fee charged when redeeming mutual fund units within aspecific period."
                //             }
                //           />
                //         }
                //         triggerType="hover"
                //         toolTipClassName="txn-mf-tooltip-info"
                //         noButton={true}
                //         button={
                //           <span>
                //             Exit Load
                //             <i className="edel-icon-Information txt_secondary-gray info-block fs-15"></i>
                //           </span>
                //         }
                //       />
                //     </span>
                //   ),
                //   value: "-",
                // },
                {
                    label: "Current NAV",
                    value: (_h = props.folio) === null || _h === void 0 ? void 0 : _h.nav,
                    valueType: EValueType.CURRENCY,
                },
                {
                    label: (React.createElement("span", null,
                        React.createElement(GenericTooltip, { placement: "bottom-start", toolTipText: React.createElement(GenericTooltipInnerContent, { tooltipTitle: "These are mutual fund units that can be redeemed or sold without any restrictions, such as lock-in periods or exit loads." }), triggerType: "hover", toolTipClassName: "txn-mf-tooltip-info", noButton: true, button: React.createElement("span", { className: "d-flex align-items-center gap-1" },
                                "Free Units",
                                React.createElement("i", { className: "edel-icon-Information txt_secondary-gray info-block fs-15" })) }))),
                    value: ((_j = props === null || props === void 0 ? void 0 : props.folio) === null || _j === void 0 ? void 0 : _j.freeQty) || "-",
                },
            ];
            setGenericDetailsAccordianData(genericDetailsAccordianData_1);
        }
    }, [props.folio]);
    var getUnits = function (amt) {
        var _a;
        return roundUpToThreeDecimalPlaces(amt / +((_a = props.folio) === null || _a === void 0 ? void 0 : _a.nav));
    };
    var handleFolioSelection = function (data) {
        var _a, _b;
        var longTermData = {};
        var maxRedAmt = +(props === null || props === void 0 ? void 0 : props.maxRedAmt) === 0
            ? (+(data === null || data === void 0 ? void 0 : data.totalQty) * +(data === null || data === void 0 ? void 0 : data.nav)).toString()
            : props === null || props === void 0 ? void 0 : props.maxRedAmt;
        if ((_a = props.purchaseFormData) === null || _a === void 0 ? void 0 : _a.isRedeemLongTerm) {
            longTermData = {
                amount: roundUpToThreeDecimalPlaces(+(data === null || data === void 0 ? void 0 : data.longTermQty) * +(data === null || data === void 0 ? void 0 : data.nav)),
                qty: data === null || data === void 0 ? void 0 : data.longTermQty,
            };
        }
        else {
            longTermData = {
                amount: (_b = props.purchaseFormData) === null || _b === void 0 ? void 0 : _b.amount,
                qty: data === null || data === void 0 ? void 0 : data.longTermQty,
            };
        }
        props.setPurchaseFormData(function (pData) {
            return __assign(__assign({}, pData), longTermData);
        });
        var highestRed = +maxRedAmt > +data.totalQty * +data.nav
            ? +data.totalQty * +data.nav
            : maxRedAmt;
        highestRed = roundUpToThreeDecimalPlaces(+highestRed);
        validateAmount(longTermData.amount, +highestRed);
        props.setPhysicalFlag(data.folioType === EReedemType.PHYSICAL
            ? EHoldingType.Physical
            : EHoldingType.Demat);
        props.setFolio(data);
    };
    var validateAmount = function (value, highestRed) {
        if (!value || (value && Number(value) <= 0)) {
            props.setFormErrors(__assign(__assign({}, props.formErrors), { amount: {
                    status: true,
                    msg: "Amount can not be blank or 0",
                } }));
        }
        else if (value &&
            Number(value) < Number(props.minRedAmt) &&
            highestRed < Number(props.minRedAmt)) {
            props.setFormErrors(__assign(__assign({}, props.formErrors), { amount: {
                    status: true,
                    msg: "Please ensure that the minimum amount to redeem is ".concat(props.minRedAmt),
                } }));
        }
        else if (value &&
            Number(value) > Number(highestRed) &&
            highestRed < Number(props.minRedAmt)) {
            props.setFormErrors(__assign(__assign({}, props.formErrors), { amount: {
                    status: true,
                    msg: "Available balance in the selected folio is less than the min amount allowed for redemption of  ".concat(props.minRedAmt),
                } }));
        }
        else if (value &&
            (Number(value) > Number(highestRed) ||
                Number(value) < Number(props.minRedAmt))) {
            props.setFormErrors(__assign(__assign({}, props.formErrors), { amount: {
                    status: true,
                    msg: "Please ensure that the entered amount is in the range  of ".concat(props.minRedAmt, " to ").concat(highestRed),
                } }));
        }
        // } else if (
        //   value &&
        //   Number(value) % (+props.minRedAmt * +props?.redAmtMul) !== 0
        // ) {
        //   props.setFormErrors({
        //     ...props.formErrors,
        //     amount: {
        //       status: true,
        //       msg: `Please ensure that the entered amount is in range of ${
        //         +props?.redAmtMul * +props?.minRedAmt
        //       } to ${+props?.redAmtMul * +highestRed} for ${props.schemeName}`,
        //     },
        //   });
        // }
        else {
            props.setFormErrors(__assign(__assign({}, props.formErrors), { amount: { status: false, msg: "" } }));
        }
    };
    var updateErrorState = function (value, isChecked) {
        var freeQtyValue = +props.folio.freeQty * +props.folio.nav;
        var marketValue = +props.folio.marketValue;
        var maxRedAmtProp = +(props === null || props === void 0 ? void 0 : props.maxRedAmt);
        var maxRedAmt = Number(maxRedAmtProp === 0
            ? Math.min(marketValue, freeQtyValue)
            : Math.min(maxRedAmtProp, freeQtyValue));
        var maximumRedeemAbleAmount = roundUpToThreeDecimalPlaces(+maxRedAmt);
        if (isChecked) {
            props.setPurchaseFormData(function (pData) {
                var _a, _b, _c, _d;
                return __assign(__assign({}, pData), { amount: Math.min(+((_a = props.folio) === null || _a === void 0 ? void 0 : _a.freeQty) * +((_b = props.folio) === null || _b === void 0 ? void 0 : _b.nav), +((_c = props.folio) === null || _c === void 0 ? void 0 : _c.longTermQty) * +((_d = props.folio) === null || _d === void 0 ? void 0 : _d.nav)), quantity: Math.min(+props.folio.freeQty, +props.folio.longTermQty) });
            });
        }
        props.setPurchaseFormData(function (pData) {
            return __assign(__assign({}, pData), { amount: value, quantity: getUnits(Number(value)) });
        });
        validateAmount(value, +maximumRedeemAbleAmount);
    };
    return (React.createElement(React.Fragment, null, !schemeError && (React.createElement("div", { className: "primary-side-txn-form-redeem-container" },
        React.createElement("div", { className: "upper-form-panel" },
            React.createElement("div", { className: "primary_sip_txn_container" },
                React.createElement("p", { className: "DMSansNormal_20_400 mb-10" },
                    React.createElement(GenericTooltip, { placement: "bottom", toolTipText: React.createElement(GenericTooltipInnerContent, { tooltipTitle: "Withdraw your investment from a mutual fund scheme and receive the amount in your bank account. Note: Exit load and tax implications may apply." }), triggerType: "hover", toolTipClassName: "txn-mf-tooltip-info", noButton: true, button: React.createElement("span", { className: "d-flex align-items-center gap-1" },
                            "Redeem",
                            React.createElement("i", { className: "edel-icon-Information txt_secondary-gray info-block fs-15" })) })),
                ((_b = (_a = props === null || props === void 0 ? void 0 : props.mfHoldingDetail) === null || _a === void 0 ? void 0 : _a.clientHoldingDetails) === null || _b === void 0 ? void 0 : _b.length) > 0 && (React.createElement(React.Fragment, null,
                    ((_d = (_c = props === null || props === void 0 ? void 0 : props.mfHoldingDetail) === null || _c === void 0 ? void 0 : _c.clientHoldingDetails) === null || _d === void 0 ? void 0 : _d.length) > 1 && (React.createElement("div", { className: "DMSansNormal_12_400 bg-pale-lemon info-txt-block" }, "Multiple folios detected. Please select a folio to redeem. Full redemption is required for multiple folios.")),
                    React.createElement(FolioSelection, { folioList: (_e = props === null || props === void 0 ? void 0 : props.mfHoldingDetail) === null || _e === void 0 ? void 0 : _e.clientHoldingDetails, folio: props === null || props === void 0 ? void 0 : props.folio, setFolio: handleFolioSelection, schemeName: props === null || props === void 0 ? void 0 : props.schemeName, isDisabled: props === null || props === void 0 ? void 0 : props.isModify }))),
                React.createElement(RedeemCard, { amount: roundUpToThreeDecimalPlaces(+((_f = props === null || props === void 0 ? void 0 : props.folio) === null || _f === void 0 ? void 0 : _f.marketValue)), timestamp: (_g = props === null || props === void 0 ? void 0 : props.folio) === null || _g === void 0 ? void 0 : _g.dpNavDate, units: (_h = props === null || props === void 0 ? void 0 : props.folio) === null || _h === void 0 ? void 0 : _h.totalQty, genericDetailsAccordianData: genericDetailsAccordianData, leftTitle: "Available To Redeem" }),
                React.createElement("div", { className: "mgt-20" },
                    React.createElement("div", { className: "d-flex" },
                        React.createElement("span", { className: "DMSans_13_400 txt_blackOne1 mgr-10 line-140" }, "Redeem")),
                    React.createElement("div", null,
                        React.createElement(InputField, { float: floatNumExp(3), autofocus: true, disabled: (_j = props.purchaseFormData) === null || _j === void 0 ? void 0 : _j.isRedeemLongTerm, inputMode: "numeric", type: "number", defaultValue: (_k = props.purchaseFormData) === null || _k === void 0 ? void 0 : _k.amount, value: (_l = props.purchaseFormData) === null || _l === void 0 ? void 0 : _l.amount, inputPattern: "[0-9]*", placeholderClassName: "amount", placeholder: "Enter amount here", "box-disable": true, 
                            // maxLength={9}
                            className: "custom-box custom-box-relative ".concat(((_m = props.purchaseFormData) === null || _m === void 0 ? void 0 : _m.isRedeemLongTerm)
                                ? "box-disable"
                                : ""), onChange: function (value) {
                                if (/^0\d/.test(value)) {
                                    value = value.replace(/^0+/, "");
                                }
                                updateErrorState(value);
                                // let mAmt = roundUpToThreeDecimalPlaces(
                                //   Number(props.folio.nav) *
                                //     Number(props.folio.freeQty)
                                // );
                            }, onKeyDown: function (e) {
                                if (acceptNumberOnly(e.key)) {
                                    e.preventDefault();
                                }
                            }, onWheel: function (e) {
                                return e.currentTarget.blur();
                            }, required: true },
                            React.createElement("div", { className: "rupee__icon position-absolute" },
                                React.createElement("span", null, "\u20B9")),
                            React.createElement("div", { className: "redeem-units-box justify-content-center flex-column align-items-start" },
                                React.createElement("span", null,
                                    "Units: ",
                                    getUnits(+((_o = props.purchaseFormData) === null || _o === void 0 ? void 0 : _o.amount))))),
                        props.formErrors.amount.status && (React.createElement("div", { className: "text-danger DMSansNormal_12_400 d-flex" },
                            React.createElement("span", null,
                                React.createElement("i", { className: "edel-icon-validation pe-1 align-middle" })),
                            React.createElement("span", null, props.formErrors.amount.msg))),
                        React.createElement("span", { className: "DMSansNormal_12_400 text_box_bottom" },
                            "Min. \u20B9",
                            +props.minRedAmt != 0
                                ? roundUpToThreeDecimalPlaces(+props.minRedAmt)
                                : 0))),
                React.createElement("div", { className: "redeem-section d-flex align-items-start mt-30" },
                    React.createElement(GenericCheckbox, { parentClassName: "individual-checkbox-wrapper", checkboxProps: {
                            onChange: function (e) {
                                var _a, _b;
                                var longTermData = {};
                                if (e.target.checked) {
                                    longTermData = {
                                        amount: roundUpToThreeDecimalPlaces(Math.min(+props.folio.freeQty, +props.folio.longTermQty) * +((_a = props === null || props === void 0 ? void 0 : props.folio) === null || _a === void 0 ? void 0 : _a.nav)),
                                        // amount: roundUpToThreeDecimalPlaces(
                                        //   +props?.folio?.longTermQty * +props?.folio.nav
                                        // ),
                                        qty: Math.min(+props.folio.freeQty, +props.folio.longTermQty).toString(),
                                    };
                                }
                                else {
                                    longTermData = {
                                        amount: (_b = props.purchaseFormData) === null || _b === void 0 ? void 0 : _b.amount,
                                    };
                                }
                                updateErrorState(longTermData.amount, e.target.checked);
                                props.setPurchaseFormData(function (pData) {
                                    return __assign(__assign(__assign({}, pData), { isRedeemLongTerm: e.target.checked }), longTermData);
                                });
                            },
                            id: "1",
                            checked: (_p = props.purchaseFormData) === null || _p === void 0 ? void 0 : _p.isRedeemLongTerm,
                            value: 11,
                            className: "m-0",
                        }, labelProps: {
                            htmlFor: "",
                            children: (React.createElement(React.Fragment, null,
                                React.createElement("div", { className: "d-flex align-items-center" }))),
                        }, checkboxType: "han-blue" }),
                    React.createElement("div", null,
                        React.createElement("span", { className: "DMSans_13_400 d-block" },
                            React.createElement(GenericTooltip, { placement: "bottom-start", toolTipText: React.createElement(GenericTooltipInnerContent, { tooltipTitle: "All long-term units which are part of your free units will be redeemed" }), triggerType: "hover", toolTipClassName: "txn-mf-tooltip-info", noButton: true, button: React.createElement("span", { className: "d-flex align-items-center gap-1" },
                                    "Redeem Long Term Units Only",
                                    " ",
                                    React.createElement("i", { className: "edel-icon-Information txt_secondary-gray info-block fs-15" })) })),
                        React.createElement("span", { className: "DMSansNormal_12_400 muted-text" }, "Helps you avoid exit loads and benefit from lower tax rates."))),
                React.createElement("div", { className: "mt-20 mb-20 horizontal-divider" }),
                React.createElement("div", { className: "DMSans_13_400 bottom-info" },
                    "Order will be processed as per the cut-off time for each fund category.",
                    React.createElement(GenericTooltip, { placement: "top-start", toolTipText: React.createElement(GenericTooltipInnerContent, { tooltipTitle: "Mutual fund transactions are processed based on the cut-off times set by regulatory guidelines. This ensures accurate pricing and timely execution of your orders. Cut-off times vary for different fund categories to align with market operations and fund management protocols." }), triggerType: "hover", toolTipClassName: "txn-mf-tooltip-info", noButton: true, externalClassName: "d-ruby mx-1", button: React.createElement("span", { className: "txt-han-blue" }, "Know Why?") }))))))));
};
export default RedeemSIP;
